/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function FlowerLotus(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M128,200s40-21.81818,40-80c0-45.58443-24.55378-68.84723-35.18644-76.78386a8.03282,8.03282,0,0,0-9.62712,0C112.55378,51.15277,88,74.41557,88,120,88,178.18182,128,200,128,200Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M128,200c11.99027-2.55021,44.33-20.78184,63.71281-54.35383S206.32158,85.26679,202.535,73.60781a7.99178,7.99178,0,0,0-9.27184-5.3531,77.437,77.437,0,0,0-31.35645,15.135"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M94.09282,83.38935a77.43686,77.43686,0,0,0-31.356-15.13464,7.99178,7.99178,0,0,0-9.27184,5.3531c-3.78659,11.659-8.56062,38.46637,10.82218,72.03836S116.00973,197.44979,128,200"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M128,200c16,0,41.83868-.1803,72.27252-17.75129s40.28226-39.5825,43.43363-50.85144a7.95859,7.95859,0,0,0-5.67817-9.83489c-7.2816-1.86638-19.78443-3.55592-35.86354.13268"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
      <Path
        d="M53.83554,121.69505c-16.0791-3.68859-28.58193-1.999-35.86352-.13267a7.95859,7.95859,0,0,0-5.67817,9.83489c3.15137,11.26894,12.99979,33.28046,43.43363,50.85144S112,200,128,200"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={24}
      />
    </Svg>
  );
}

export default FlowerLotus;
